module.exports = __webpack_public_path__ + "static/images/crypticmag_splash.56dfe42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/crypticmag_splash.jpg
// module id = 90T0
// module chunks = 1